// web/src/store/phone/_state.ts —— 内部：运行期可变状态容器 rt（跨分片共享，ES 模块不能给 import 赋值）
// 拆自 web/src/store/phone.ts 的同名分区（内容原样搬运）；由 web/src/store/phone.ts 以 export * 聚合，导出面对调用方不变。

import { Invitation, Inviter, Registerer, RegistererState, Session, SessionState, TransportState, UserAgent, UserAgentRegisteredOptionTags } from 'sip.js';
import { createZitchAgent, type ZitchAgent, type ZitchEvent } from '../../lib/zitchAgent';
/**
 * 运行期可变状态容器：这些绑定会被多个分片读写，而 ES 模块不能给 import 赋值（TS2632），
 * 故统一收进本对象——写的是对象属性，语义与原来的模块级变量完全等价。
 */
export const rt = {
  cachedFsDomain: null as string | null,
  runtimeEngine: null as 'freeswitch' | 'zitch' | null,
  ua: null as UserAgent | null,
  registerer: null as Registerer | null,
  session: null as Session | null,
  audio: null as HTMLAudioElement | null,
  currentExt: '',
  registerSeq: 0,
  userLogout: false,
  wsEverDropped: false,
  lastHealAt: 0,
  zitch: null as ZitchAgent | null,
  zitchExt: '',
  lastOutboundDial: '',
  activeOutboundSeq: 0,
  outboundSeq: 0,
  manualHangup: false,
};

